// extracted by mini-css-extract-plugin
module.exports = {"body":"App_body__2Utmu","buttons":"App_buttons__1KAUd","tierText":"App_tierText__3O5jb"};